import { render, staticRenderFns } from "./TradingOrderHistoryItems.vue?vue&type=template&id=99c9fb34&scoped=true&"
import script from "./TradingOrderHistoryItems.vue?vue&type=script&lang=js&"
export * from "./TradingOrderHistoryItems.vue?vue&type=script&lang=js&"
import style0 from "./TradingOrderHistoryItems.vue?vue&type=style&index=0&id=99c9fb34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c9fb34",
  null
  
)

export default component.exports